/**
 * Grand Quack Auto — duckling ambient chirp sounds.
 *
 * Web Audio API sine blips in the baby-duck register (800-1200 Hz).
 * Volume and duration scale with brood size — more ducklings = louder flock.
 */

import { DUCKLING_CHIRP } from '../config';
import { isAudioActive } from './audio';
import { getCtx, getDestination } from './audioMixer';

/** Play a single duckling chirp. broodSize scales volume and duration. */
export function playDucklingChirp(broodSize: number): void {
  const c = getCtx();
  if (c.state === 'suspended') return; // don't force resume — wait for user gesture
  if (!isAudioActive()) return;        // audio killed on death/end

  const now = c.currentTime;
  const freq = DUCKLING_CHIRP.freqMin
    + Math.random() * (DUCKLING_CHIRP.freqMax - DUCKLING_CHIRP.freqMin);
  const duration = DUCKLING_CHIRP.duration + (broodSize / 10) * 0.04;
  const gain = DUCKLING_CHIRP.gainBase + broodSize * DUCKLING_CHIRP.gainPerDuckling;

  const osc = c.createOscillator();
  osc.type = 'sine';
  osc.frequency.setValueAtTime(freq, now);
  // Slight downward pitch slide for natural chirp feel.
  osc.frequency.exponentialRampToValueAtTime(freq * 0.7, now + duration);

  const g = c.createGain();
  g.gain.setValueAtTime(0, now);
  g.gain.linearRampToValueAtTime(gain, now + 0.005);
  g.gain.exponentialRampToValueAtTime(0.001, now + duration);

  osc.connect(g).connect(getDestination());
  osc.start(now);
  osc.stop(now + duration);
}
